import { useEffect } from 'react';

import { getUpdatedDeliveryMethod } from '../utils/general';

import type { UseUpdatedDeliveryMethodParams } from './types';

export const useUpdatedDeliveryMethod = ({
  cohortName,
  userRoles,
  currentDeliveryMethod,
  sessionId,
  selectedClientId,
  setDeliveryMethod,
}: UseUpdatedDeliveryMethodParams) => {
  useEffect(() => {
    const updatedDeliveryMethod = getUpdatedDeliveryMethod({
      cohortName,
      userRoles,
      currentDeliveryMethod,
      sessionId,
    });

    if (updatedDeliveryMethod) {
      setDeliveryMethod(updatedDeliveryMethod);
    }
  }, [cohortName, selectedClientId, setDeliveryMethod, sessionId, userRoles, currentDeliveryMethod]);
};
